import * as React from 'react';

import type { TrackingContextData } from 'js/lib/retracked';

import type { StaffManagementScopeData } from '../types/eventingTypes';
import { StaffPermissionsEventing } from './StaffPermissionsEventing';
import UserRoleView from './UserRoleView';

interface Props {
  partnerId: number | string | undefined;
  userId: number | string | undefined;
  ingressPointScopeData: StaffManagementScopeData;
  eventData: TrackingContextData | undefined;
}

const UserRoleViewContainer = ({ partnerId, userId, ingressPointScopeData, eventData }: Props) => {
  if (!partnerId || !userId) {
    return null;
  }

  return (
    <StaffPermissionsEventing targetUserId={userId} ingressPointScopeData={ingressPointScopeData} eventData={eventData}>
      <UserRoleView partnerId={partnerId} userId={userId} />
    </StaffPermissionsEventing>
  );
};

export default UserRoleViewContainer;
